import '../scss/main.scss'
import 'glightbox/dist/css/glightbox.min.css'

import $ from 'jquery'

global.$ = global.jQuery = $;

import './vendor/owl.carousel.min.js'
import './vendor/jquery.mousewheel.min.js'

import GLightbox from 'glightbox'

import Menu from './components/menu'
import ArticlesList from './components/articles-list'
import Configuration from './components/configuration'
import Timeline from './components/timeline'
import LogoCarrousel from './components/logo-carousel'
import SolutionList from './components/solutions-list'
import MapDynamicContact from './components/map-dynamic-contact'
// import DropDown from './components/dropdown-contact'
// import ModalForm from './components/modal-form'

import Homepage from './pages/homepage'
import HiddenPhone from './components/hidden-phone'

(function (global, factory) {
        typeof exports === 'object' && typeof module !== 'undefined' ? factory() :
            typeof define === 'function' && define.amd ? define(factory) :
                (factory());
    }(this, (function () {
        'use strict';

        window.addEventListener('load', function () {

            Menu();

            Homepage();

            Configuration();

            Timeline();

            LogoCarrousel();

            ArticlesList();

            SolutionList();

            MapDynamicContact();

            // DropDown();

            HiddenPhone();

            // ModalForm();

            const lightbox = GLightbox({});

        }, false);
    }))
);
